import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconsStandaloneComponent implements OnChanges {
  @Input() color?: string;
  @Input() top?: string;
  @Input() wrapperClass?: string;
  @Input()
  get name(): string {
    return this._name;
  }
  set name(name: string) {
    this._name = name;
    this.setClasses();
  }
  private _name = '';

  @Input()
  get classes(): string {
    return this._classes;
  }
  set classes(value: string) {
    this._classes = value;
    this.setClasses();
  }
  private _classes = '';

  classNames: string;
  style: { [key: string]: string } = {};

  constructor(private elmRef: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.color) {
      this.color = changes.color.currentValue;
    }

    this.setStyle();
  }

  setClasses(): void {
    const outerToInnerClass = this.elmRef.nativeElement.className || '';
    this.classNames = `icon icon_type_${this.name} ${outerToInnerClass} ${this.classes}`;

    this.setStyle();

    this.elmRef.nativeElement.className = `app-icon ${this.wrapperClass}`;
  }

  setStyle() {
    if (this.color) {
      this.style.color = this.color;
    }

    if (this.top) {
      this.style.top = this.top;
    }
  }
}
